<script setup lang="ts">
import { InputField } from '@caks/uikit/input'
import { ButtonMain } from '@caks/uikit/button'
import { useAccountStore } from '@caks/shared/store/store.account'
import { postPromoValidation } from '@caks/shared/api/user.route'

const emit = defineEmits<{ (emit: 'close'): void }>()
const store = useAccountStore()

const promo = ref('')
const error = ref(false)

const applyPromo = async () => {
  error.value = false

  const { data, status } = await postPromoValidation(promo.value)

  if (status === 'OK') {
    store.setPromo(data)
    localStorage.setItem('promo', JSON.stringify(data))

    emit('close')
  } else {
    error.value = true
  }
}
</script>

<template>
  <div class="promo">
    <h3 class="promo__title">Промокод</h3>
    <input-field v-model="promo" placeholder="Введите промокод" />
    <p v-if="error" class="promo__not-found">Промокод не найден</p>
    <button-main @click="applyPromo" :disabled="!promo">Применить</button-main>
  </div>
</template>

<style scoped lang="scss">
.promo {
  width: 384px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  &__title {
    @include h2-1;
  }

  button {
    margin-top: 12px;
    width: 100%;
  }

  &__not-found {
    color: $primary-red;
    @include h4-8;
  }
}
</style>
